/* istanbul ignore file */
import { persistStore } from "redux-persist";
import { setupStore } from "./store";

const store = setupStore();
const persistor = persistStore(store);

export { store, persistor };
